import Vue from 'vue';
import { gsap } from 'gsap';
import Axios from 'axios';
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';


Vue.component('search-component', {
    data() {
        return {
            // showSearch: false,
            // searchData: [],
            // noResults: false,
            // searchInputValue: ''
        }
    },

    mounted() {
        document.getElementById('searchParam').focus();
    },

    filters: {
        // dateToDayNumber: function (val) {
        //     return format(new Date(val), "dd")
        // },
        // dateToShortMonth: function (val) {
        //     return format(new Date(val), "MMM", { locale: nl }).replace(/\./g, '');
        // }
    },

    computed: {
        // events: function () {
        //     return this.searchData.filter((o, i) => {
        //         return o.section.handle === 'events' || o.section.handle === 'paradisoEvents';
        //     })
        // },
        // others: function () {
        //     return this.searchData.filter((o, i) => {
        //         return o.section.handle !== 'events' && o.section.handle !== 'paradisoEvents';
        //     })
        // }
    },

    methods: {
        // toggleSearch(event) {


        //     const searchOverlay = document.querySelector('.search-overlay');

        //     if (this.showSearch) {
        //         searchOverlay.classList.remove('open')
        //         gsap.to(searchOverlay, { height: 0, minHeight: 0 });
        //         this.showSearch = !this.showSearch;
        //         return;
        //     }

        //     gsap.to(searchOverlay, { height: 'auto', minHeight: '100%' });
        //     searchOverlay.classList.add('open');
        //     document.getElementById('searchParamOverlay').focus();
        //     this.showSearch = !this.showSearch;
        // },

        // async submitSearchRequest() {
        //     const searchParam = this.searchInputValue;

        //     await Axios.get('/api/search?q=' + searchParam)
        //         .then((response) => {
        //             // handle success
        //             this.searchData = response.data.data;
        //             // return data;
        //         })
        //         .catch((error) => {
        //             // handle error
        //             console.log(error);
        //         });

        //     this.noResults = (this.searchData.length === 0);
        // }
    },

    beforeDestroy() {

    }
});
